import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { apiBaseUrl, setAuthToken } from "../utils/api";

export default function Login() {
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [step, setStep] = useState("mobile");

  // Temporary store after sending OTP
  const [tempAccessToken, setTempAccessToken] = useState("");
  const [tempRefreshToken, setTempRefreshToken] = useState("");
  const [tempUniqueId, setTempUniqueId] = useState("");
  const { uniqueId, setUniqueId } = useAuth();

  const { login } = useAuth();
  const navigate = useNavigate();

  // Step 1: Send OTP
  const sendOtp = async () => {
    try {
      const res = await fetch(`${apiBaseUrl}/api/auth/auth`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mobile }),
      });

      const data = await res.json();
      console.log("Send OTP result", data);

      if (res.ok) {
        // Save tokens + uniqueId temporarily for verify step
        setTempAccessToken(data.accessToken);
        setTempRefreshToken(data.refreshToken);
        setTempUniqueId(data.user.uniqueId);
        setUniqueId(data.user.uniqueId);
        setStep("otp");
      } else {
        alert(data.message || "Failed to send OTP");
      }
    } catch (err) {
      console.error("Error sending OTP:", err);
      alert("Something went wrong while sending OTP");
    }
  };

  // Step 2: Verify OTP
  const verifyOtp = async () => {
    try {
      const res = await fetch(`${apiBaseUrl}/api/auth/otp/verify-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tempAccessToken}`, // send temp token if needed
        },
        body: JSON.stringify({
          mobile,
          otp,
          uniqueId: tempUniqueId,
        }),
      });

      const data = await res.json();
      console.log("Verify OTP result", data);

      if (res.ok && data.message === "OTP verified successfully") {
        // If backend returns token & uniqueId, save them
        if (data.accessToken && data.refreshToken && data.user?.uniqueId) {
          login(
            { accessToken: data.accessToken, refreshToken: data.refreshToken },
            data.user.uniqueId
          );
          setAuthToken(data.accessToken);
        }
        navigate("/myVouchers");
      } else {
        alert(data.message || "Invalid OTP");
      }
    } catch (err) {
      console.error("Error verifying OTP:", err);
      alert("Something went wrong while verifying OTP");
    } finally {
    }
  };

  return (
    <div>
      {step === "mobile" && (
        <>
          <h2>Login</h2>
          <input
            type="text"
            placeholder="Enter mobile"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
          />
          <button onClick={sendOtp}>Send OTP</button>
        </>
      )}

      {step === "otp" && (
        <>
          <h2>Enter OTP</h2>
          <input
            type="text"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
          />
          <button onClick={verifyOtp}>Verify</button>
        </>
      )}
    </div>
  );
}
